/* eslint-disable no-debugger */
import {formatPrice} from './currency-format'
import {getSortedArray} from './array-helper'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import advancedFormat from 'dayjs/plugin/advancedFormat'
dayjs.extend(utc)
dayjs.extend(advancedFormat)
dayjs.extend(timezone)

// Keap Text & Voice tier mappings by currency (amount -> tier/quantity)
const KEAP_TEXT_VOICE_TIERS = {
  USD: {14: '1', 24: '2', 39: '3', 79: '4', 139: '5', 279: '6'},
  CAD: {19: '1', 33: '2', 53: '3', 107: '4', 188: '5', 377: '6'},
  AUD: {21: '1', 40: '2', 65: '3', 130: '4', 230: '5', 465: '6'},
  NZD: {40: '2', 65: '3', 132: '4', 232: '5', 465: '6'},
  GBP: {19: '2', 31: '3', 62: '4', 108: '5', 219: '6'},
}

// Keap Additional Contacts tier mappings by currency (amount -> contacts quantity)
const KEAP_CONTACTS_TIERS = {
  USD: {
    36: '1000',
    84: '2500',
    150: '5000',
    240: '10000',
    330: '15000',
    420: '25000',
    480: '50000',
    600: '75000',
    720: '100000',
    1200: '200000',
    1980: '500000',
    2940: '750000',
    3720: '1000000',
    5940: '2000000',
    7200: '3000000',
    8460: '4000000',
    10140: '5000000',
  },
  CAD: {
    49: '1000',
    114: '2500',
    203: '5000',
    325: '10000',
    446: '15000',
    568: '25000',
    649: '50000',
    811: '75000',
    973: '100000',
    1622: '200000',
    2676: '500000',
    3973: '750000',
    5027: '1000000',
    8027: '2000000',
    9730: '3000000',
    11433: '4000000',
    13703: '5000000',
  },
  AUD: {
    42: '1000',
    98: '2500',
    178: '5000',
    282: '10000',
    389: '15000',
    496: '25000',
    567: '50000',
    707: '75000',
    850: '100000',
    1415: '200000',
    1865: '500000',
    3458: '750000',
    4376: '1000000',
    6989: '2000000',
    8471: '3000000',
    9953: '4000000',
    11930: '5000000',
  },
  NZD: {
    46: '1000',
    108: '2500',
    196: '5000',
    310: '10000',
    428: '15000',
    546: '25000',
    624: '50000',
    778: '75000',
    935: '100000',
    1557: '200000',
    2052: '500000',
    3804: '750000',
    4814: '1000000',
    7689: '2000000',
    9319: '3000000',
    10949: '4000000',
    13124: '5000000',
  },
  GBP: {
    29: '1000',
    68: '2500',
    122: '5000',
    196: '10000',
    269: '15000',
    342: '25000',
    390: '50000',
    488: '75000',
    586: '100000',
    976: '200000',
    1609: '500000',
    2390: '750000',
    3024: '1000000',
    4829: '2000000',
    5854: '3000000',
    6878: '4000000',
    8244: '5000000',
  },
}

const KEAP_CONTACTS_TIERS_ANNUAL = {
  USD: {
    1000: '346',
    2500: '792',
    5000: '1440',
    10000: '2304',
    15000: '3168',
    25000: '4032',
    50000: '4608',
    75000: '5760',
    100000: '6912',
    200000: '11520',
    500000: '19008',
    750000: '28224',
    1000000: '35712',
    2000000: '57024',
    3000000: '69120',
    4000000: '81216',
    5000000: '97344',
  },
  CAD: {
    1000: '470',
    2500: '1094',
    5000: '1949',
    10000: '3120',
    15000: '4282',
    25000: '5462',
    50000: '6230',
    75000: '7786',
    100000: '9341',
    200000: '15571',
    500000: '25690',
    750000: '38141',
    1000000: '48259',
    2000000: '77059',
    3000000: '93408',
    4000000: '109757',
    5000000: '131549',
  },
  AUD: {
    1000: '432',
    2500: '972',
    5000: '1775',
    10000: '2833',
    15000: '3900',
    25000: '4968',
    50000: '5676',
    75000: '7092',
    100000: '8507',
    200000: '14185',
    500000: '23400',
    750000: '34740',
    1000000: '43956',
    2000000: '70188',
    3000000: '85067',
    4000000: '99960',
    5000000: '119808',
  },
  NZD: {
    1000: '442',
    2500: '1037',
    5000: '1882',
    10000: '2976',
    15000: '4109',
    25000: '5453',
    50000: '5990',
    75000: '7469',
    100000: '8976',
    200000: '14947',
    500000: '19699',
    750000: '36518',
    1000000: '46214',
    2000000: '73814',
    3000000: '89462',
    4000000: '105110',
    5000000: '125990',
  },
  GBP: {
    1000: '278',
    2500: '653',
    5000: '1171',
    10000: '1872',
    15000: '2578',
    25000: '3283',
    50000: '3744',
    75000: '4680',
    100000: '5616',
    200000: '9360',
    500000: '15451',
    750000: '22939',
    1000000: '29030',
    2000000: '46368',
    3000000: '56189',
    4000000: '66024',
    5000000: '79142',
  },
}

const KEAP_TEXT_VOICE_TIERS_ANNUAL = {
  USD: {
    2: '288',
    3: '468',
    4: '948',
    5: '1668',
    6: '3348',
  },
  CAD: {
    2: '384',
    3: '636',
    4: '1284',
    5: '2256',
    6: '4524',
  },
  AUD: {
    2: '480',
    3: '780',
    4: '1560',
    5: '2760',
    6: '5580',
  },
  NZD: {
    2: '288',
    3: '468',
    4: '948',
    5: '1668',
    6: '3348',
  },
  GBP: {
    2: '228',
    3: '372',
    4: '744',
    5: '1296',
    6: '2628',
  },
}

const GRAPHLY_CONTACTS_OPTIONS_MONTHLY = {
  USD: {
    1000: '10',
    2500: '15',
    5000: '20',
    10000: '30',
    25000: '50',
    50000: '80',
    75000: '100',
    100000: '120',
    200000: '200',
    500000: '350',
    750000: '500',
    1000000: '700',
    2000000: '950',
    3000000: '1150',
    4000000: '1300',
    5000000: '1400',
  },
  CAD: {
    1000: '14',
    2500: '20',
    5000: '28',
    10000: '41',
    25000: '70',
    50000: '110',
    75000: '138',
    100000: '166',
    200000: '275',
    500000: '483',
    750000: '690',
    1000000: '967',
    2000000: '1312',
    3000000: '1588',
    4000000: '1795',
    5000000: '1933',
  },
  AUD: {
    1000: '16.20',
    2500: '24.30',
    5000: '32.41',
    10000: '48.61',
    25000: '81.03',
    50000: '129.65',
    75000: '162.06',
    100000: '194.47',
    200000: '324.13',
    500000: '567.21',
    750000: '810.32',
    1000000: '1134.44',
    2000000: '1539.59',
    3000000: '1863.72',
    4000000: '2106.82',
    5000000: '2269.98',
  },
  NZD: {
    1000: '16.20',
    2500: '24.30',
    5000: '32.41',
    10000: '48.61',
    25000: '81.03',
    50000: '129.65',
    75000: '162.06',
    100000: '194.47',
    200000: '324.13',
    500000: '567.22',
    750000: '810.32',
    1000000: '1134.44',
    2000000: '1539.59',
    3000000: '1863.72',
    4000000: '2106.82',
    5000000: '2269.98',
  },
  GBP: {
    1000: '8.15',
    2500: '12.23',
    5000: '16.31',
    10000: '24.46',
    25000: '40.77',
    50000: '65.24',
    75000: '81.55',
    100000: '97.86',
    200000: '163.10',
    500000: '285.42',
    750000: '407.75',
    1000000: '570.85',
    2000000: '774.72',
    3000000: '937.82',
    4000000: '1060.15',
    5000000: '1141.70',
  },
}

const GRAPHLY_CONTACTS_OPTIONS_ANNUAL = {
  USD: {
    1000: '102',
    2500: '153',
    5000: '204',
    10000: '306',
    25000: '510',
    50000: '816',
    75000: '1020',
    100000: '1224',
    200000: '1663.62',
    500000: '3570',
    750000: '5100',
    1000000: '7140',
    2000000: '9690',
    3000000: '11730',
    4000000: '13260',
    5000000: '14280',
  },
  CAD: {
    1000: '142.80',
    2500: '204',
    5000: '285.50',
    10000: '418.20',
    25000: '714',
    50000: '1122',
    75000: '1407',
    100000: '1693.20',
    200000: '2805',
    500000: '4926.40',
    750000: '7038',
    1000000: '9863.40',
    2000000: '13382.40',
    3000000: '16197.60',
    4000000: '18309',
    5000000: '19716',
  },

  AUD: {
    1000: '165.30',
    2500: '247.95',
    5000: '330.61',
    10000: '495.90',
    25000: '826.52',
    50000: '1322.43',
    75000: '1653.04',
    100000: '1983.64',
    200000: '3306.08',
    500000: '5785.65',
    750000: '8265.21',
    1000000: '11571.30',
    2000000: '15703.90',
    3000000: '19009.98',
    4000000: '21489.55',
    5000000: '23142.59',
  },
  NZD: {
    1000: '165.27',
    2500: '247.85',
    5000: '330.54',
    10000: '495.81',
    25000: '826.47',
    50000: '1322.39',
    75000: '1653.04',
    100000: '1983.58',
    200000: '3306.09',
    500000: '5785.59',
    750000: '8265.21',
    1000000: '11571.30',
    2000000: '15703.85',
    3000000: '19009.93',
    4000000: '21489.55',
    5000000: '23142.82',
  },
  GBP: {
    1000: '83.18',
    2500: '124.77',
    5000: '166.36',
    10000: '249.54',
    25000: '415.90',
    50000: '665.44',
    75000: '831.81',
    100000: '998.17',
    200000: '2040',
    500000: '2911.33',
    750000: '4159.05',
    1000000: '5822.67',
    2000000: '7902.19',
    3000000: '9566.81',
    4000000: '10813.53',
    5000000: '11645.34',
  },
}

const PLUS_THIS_PREMIUM_MONTHLY = {
  USD: {
    200000: '199',
    500000: '299',
    1000000: '499',
    2000000: '699',
  },
  CAD: {
    200000: '269',
    500000: '405',
    1000000: '700',
    2000000: '965',
  },
  AUD: {
    200000: '323',
    500000: '418',
    1000000: '700',
    2000000: '980',
  },
  NZD: {
    200000: '332',
    500000: '462',
    1000000: '770',
    2000000: '1078',
  },
  GBP: {
    200000: '135',
    500000: '223',
    1000000: '372',
    2000000: '520',
  },
}

const PLUS_THIS_PREMIUM_ANNUAL = {
  USD: {
    200000: '2388',
    500000: '3588',
    1000000: '5988',
    2000000: '8388',
  },
  CAD: {
    200000: '3288',
    500000: '4860',
    1000000: '8400',
    2000000: '11580',
  },
  AUD: {
    200000: '3876',
    500000: '5016',
    1000000: '8400',
    2000000: '11760',
  },
  NZD: {
    200000: '3894',
    500000: '5544',
    1000000: '9240',
    2000000: '12936',
  },
  GBP: {
    200000: '1620',
    500000: '2676',
    1000000: '4464',
    2000000: '6240',
  },
}
const getKeapAddonUnitamountByQuantity = (
  code,
  amount,
  currency = 'USD',
  quantity = 1,
) => {
  if (String(code || '').includes('addon-5-keap-addcontacts-annual')) {
    const tiers =
      KEAP_CONTACTS_TIERS_ANNUAL[currency] || KEAP_CONTACTS_TIERS_ANNUAL.USD
    const matchedAmount = tiers[quantity]
    return matchedAmount ? parseFloat(matchedAmount).toFixed(2) : 0
  }

  if (String(code || '').includes('addon-5-keap-textvoice-annual')) {
    const tiers =
      KEAP_TEXT_VOICE_TIERS_ANNUAL[currency] || KEAP_TEXT_VOICE_TIERS_ANNUAL.USD
    const matchedAmount = tiers[quantity]
    return matchedAmount ? parseFloat(matchedAmount).toFixed(2) : 0
  }

  if (
    String(code || '').includes('addon-5-keap-legacy-graphly-contacts-annual')
  ) {
    const tiers =
      GRAPHLY_CONTACTS_OPTIONS_ANNUAL[currency] ||
      GRAPHLY_CONTACTS_OPTIONS_ANNUAL.USD
    const matchedAmount = tiers[quantity]
    return matchedAmount ? parseFloat(matchedAmount).toFixed(2) : 0
  }

  if (String(code || '').includes('addon-5-keap-legacy-graphly-contacts-m2m')) {
    const tiers =
      GRAPHLY_CONTACTS_OPTIONS_MONTHLY[currency] ||
      GRAPHLY_CONTACTS_OPTIONS_MONTHLY.USD
    const matchedAmount = tiers[quantity]
    return matchedAmount ? parseFloat(matchedAmount).toFixed(2) : 0
  }

  if (
    String(code || '').includes(
      'addon-5-keap-legacy-plusthis-premium-trans-annual',
    )
  ) {
    const tiers =
      PLUS_THIS_PREMIUM_ANNUAL[currency] || PLUS_THIS_PREMIUM_ANNUAL.USD
    const matchedAmount = tiers[quantity]
    return matchedAmount ? parseFloat(matchedAmount).toFixed(2) : 0
  }

  if (
    String(code || '').includes(
      'addon-5-keap-legacy-plusthis-premium-trans-m2m',
    )
  ) {
    const tiers =
      PLUS_THIS_PREMIUM_MONTHLY[currency] || PLUS_THIS_PREMIUM_MONTHLY.USD
    const matchedAmount = tiers[quantity]
    return matchedAmount ? parseFloat(matchedAmount).toFixed(2) : 0
  }

  if (String(code || '').includes('addon-5-keap-textvoice')) {
    const tiers = KEAP_TEXT_VOICE_TIERS[currency] || KEAP_TEXT_VOICE_TIERS.USD
    const entry = Object.entries(tiers).find(
      ([, tier]) => parseFloat(tier) === parseFloat(quantity),
    )
    return entry ? parseFloat(entry[0]).toFixed(2) : 0
  }

  if (String(code || '').includes('addon-5-keap-addcontacts')) {
    const tiers = KEAP_CONTACTS_TIERS[currency] || KEAP_CONTACTS_TIERS.USD
    const entry = Object.entries(tiers).find(
      ([, contacts]) => parseFloat(contacts) === parseFloat(quantity),
    )
    return entry ? parseFloat(entry[0]).toFixed(2) : 0
  }

  return parseFloat(amount) || 0
}

/**
 * Get the quantity/tier for keap addons based on amount and currency

 */
const getKeapAddonQuantityByAmount = (
  code,
  amount,
  currency = 'USD',
  quantity = 1,
) => {
  if (String(code || '').includes('addon-5-keap-addcontacts-annual')) {
    return 1
  }
  if (String(code || '').includes('addon-5-keap-textvoice-annual')) {
    return 1
  }

  if (!amount) {
    if (
      String(code || '').includes('addon-5-keap-textvoice') ||
      String(code || '').includes('addon-5-keap-addcontacts') ||
      String(code || '').includes('addon-5-keap-legacy-graphly-contacts') ||
      String(code || '').includes('addon-5-keap-legacy-plusthis')
    ) {
      return 1
    }
    return quantity
  }

  const numAmount = Number(amount)

  if (String(code || '').includes('addon-5-keap-textvoice')) {
    const tiers = KEAP_TEXT_VOICE_TIERS[currency] || KEAP_TEXT_VOICE_TIERS.USD
    const tier = tiers[numAmount]
    return tier ? parseFloat(tier).toFixed(2) : quantity
  }

  if (String(code || '').includes('addon-5-keap-addcontacts')) {
    const tiers = KEAP_CONTACTS_TIERS[currency] || KEAP_CONTACTS_TIERS.USD
    const contacts = tiers[numAmount]
    return contacts ? parseFloat(contacts).toFixed(2) : quantity
  }

  return quantity
}

const orderJSON = {
  coupons: [
    {
      name: 'New Customer Incentive Marketing Center',
      isValid: true,
      description: 'Marketing Center One Invoice Free',
      type: 'percent',
      duration: 'single_use',
      durationUnit: null,
      durationAmount: null,
      appliesToAllPlans: false,
      appliesToPlans: [
        'previewtax',
        'mc_pro-5-thryv-m2m',
        'mc_plus-5-thryv-m2m',
        'convenience-fee',
      ],
      isPercentDiscount: true,
      discountAmount: 0,
      discountPercent: 100,
      code: 'nci-mc',
    },
  ],
  plans: [
    {
      id: 'sww2xqbxxzxn',
      code: 'mc_pro-5-thryv-m2m',
      name: 'Marketing Center Pro',
      quantity: 1,
      intervalLength: 1,
      intervalUnit: 'months',
      currency: {
        currency: 'USD',
        setupFee: 0,
        unitAmount: 358,
      },
      addons: [],
      transitionApplies: true,
    },
    {
      id: 'vbqr2yjruz9q',
      code: 'rc_plus-5-thryv-m2m',
      name: 'Reporting Center Plus',
      quantity: 1,
      intervalLength: 1,
      intervalUnit: 'months',
      currency: {
        currency: 'USD',
        setupFee: 0,
        unitAmount: 51,
      },
      addons: [],
      transitionApplies: false,
    },
    {
      id: 'vj8d6f9bt3yo',
      code: 'seobase-5-thryv-m2m',
      name: 'AEO & SEO',
      quantity: 1100,
      intervalLength: 1,
      intervalUnit: 'months',
      currency: {
        currency: 'USD',
        setupFee: 0,
        unitAmount: 1,
      },
      addons: [
        {
          id: 'vj9as0xlyvrz',
          code: 'addon-5-seokey-m2m',
          name: 'SEO Keywords',
          quantity: 1,
          currencies: [
            {
              currency: 'AUD',
              unitAmount: 600,
            },
            {
              currency: 'CAD',
              unitAmount: 0,
            },
            {
              currency: 'NZD',
              unitAmount: 700,
            },
            {
              currency: 'USD',
              unitAmount: 400,
            },
          ],
        },
        {
          id: 'vj9as0xm5dm5',
          code: 'addon-5-seopb-m2m',
          name: 'SEO PowerBoost',
          quantity: 1,
          currencies: [
            {
              currency: 'AUD',
              unitAmount: 600,
            },
            {
              currency: 'CAD',
              unitAmount: 0,
            },
            {
              currency: 'NZD',
              unitAmount: 700,
            },
            {
              currency: 'USD',
              unitAmount: 400,
            },
          ],
        },
      ],
      transitionApplies: false,
    },
    {
      id: 'swv5n2fg12us',
      code: 'appmarket-5-thryv-m2m',
      name: 'Thryv Add-Ons',
      quantity: 1,
      intervalLength: 1,
      intervalUnit: 'months',
      currency: {
        currency: 'USD',
        setupFee: 0,
        unitAmount: 0,
      },
      addons: [
        {
          id: 't3l27ic1fdum',
          code: 'addon-5-signatures_usage',
          name: 'Signatures Usage',
          quantity: 1,
          currencies: [],
        },
        {
          id: 't6ytsi2ykfe1',
          code: 'app-websitebuilder',
          name: 'Website Builder',
          quantity: 1,
          currencies: [
            {
              currency: 'AUD',
              unitAmount: 0,
            },
            {
              currency: 'CAD',
              unitAmount: 0,
            },
            {
              currency: 'NZD',
              unitAmount: 0,
            },
            {
              currency: 'USD',
              unitAmount: 0,
            },
          ],
        },
        {
          id: 'vm1udwhyxl5v',
          code: 'addon-5-mcexpangr',
          name: 'Expanded Growth Package',
          quantity: 1,
          currencies: [
            {
              currency: 'AUD',
              unitAmount: 454.55,
            },
            {
              currency: 'CAD',
              unitAmount: 0,
            },
            {
              currency: 'NZD',
              unitAmount: 500,
            },
            {
              currency: 'USD',
              unitAmount: 500,
            },
          ],
        },
      ],
      transitionApplies: false,
    },
    {
      id: 'swfnqfat3lcf',
      code: 'cc_basicpls-5-thryv-m2m',
      name: 'My Account Basic+',
      quantity: 1,
      intervalLength: 1,
      intervalUnit: 'months',
      currency: {
        currency: 'USD',
        setupFee: 0,
        unitAmount: 0,
      },
      addons: [],
      transitionApplies: false,
    },
    {
      id: 'szppd9c7or2j',
      code: 'thryvprfee',
      name: 'Onboarding Fee',
      currency: {
        currency: 'USD',
        unitAmount: 250,
      },
      quantity: 1,
    },
  ],
  businessAddress: {
    address: '2200 West Airfield Drive',
    city: 'Dallas',
    state: 'TX',
    postalCode: '76051',
    xpCode: null,
    firstName: 'Credit',
    lastName: 'Cleaning',
    phone: '3174312304',
  },
  country: 'US',
  balanceInfo: {
    currency: 'USD',
    amount: -50,
    processingPrepaymentAmount: 0,
    availableCreditAmount: -50,
  },
  curr: 'USD',
  flow: 'new',
  isInvoiceBilled: false,
  isCohort: false,
}

console.log(orderJSON)

const getPlanDetail = (currency, plan) => {
  let currencyDetails = plan?.currencies
    ? plan.currencies.find(item => item.currency === currency)
    : plan?.currency
  let planAmount = (currencyDetails?.unitAmount || 0) * plan.quantity || 0

  return {
    name: plan.name,
    amount: planAmount,
    quantity: plan.quantity,
    code: plan.code,
    type: plan,
  }
}

export const getMonthlySubDetails = (subJSON, currency) => {
  let monthlyCenters = []
  let monthlyAddons = []
  subJSON.plans.map(item => {
    let isCenter = item.name.toLowerCase().includes('center')
    if (isCenter) {
      monthlyCenters.push(getPlanDetail(currency, item))
      if (item.addons.length > 0) {
        item.addons.map(addonItem => {
          if (!(
            addonItem.name.toLowerCase().includes('marketing') ||
            addonItem.name.toLowerCase().includes('center')
          )) {
            console.log({name: addonItem.name})
            monthlyAddons.push(getPlanDetail(currency, addonItem))
          }
          return addonItem
        })
      }
    } else if (item.code === 'appmarket-5-thryv-m2m') {
      if (item.addons.length > 0) {
        item.addons.map(addonItem => {
          monthlyAddons.push(getPlanDetail(currency, addonItem))
          return addonItem
        })
      }
    } else {
      monthlyAddons.push(getPlanDetail(currency, item))
    }
    return item
  })
  monthlyCenters = getSortedArray(monthlyCenters, 'name')
  monthlyAddons = getSortedArray(monthlyAddons, 'name')
  let cartList = [...monthlyCenters, ...monthlyAddons]
  let monthlyCartTotal = cartList
    .map(item => item.amount)
    .reduce((acc, curr) => acc + curr)
  return {
    cartList,
    totalDue: formatPrice({
      amount: monthlyCartTotal,
      country: currency === 'GBP' ? 'GB' : 'US',
    }),
    paymentCartType: 'monthly',
  }
}
export const getDailySubDetails = (subJSON, currency) => {
  let monthlyCenters = []
  let monthlyAddons = []
  subJSON.plans.map(item => {
    let isCenter = item.name.toLowerCase().includes('center')
    if (isCenter) {
      monthlyCenters.push(getPlanDetail(currency, item))
      if (item.addons.length > 0) {
        item.addons.map(addonItem => {
          if (!(
            addonItem.name.toLowerCase().includes('marketing') ||
            addonItem.name.toLowerCase().includes('center')
          )) {
            console.log({name: addonItem.name})
            monthlyAddons.push(getPlanDetail(currency, addonItem))
          }
          return addonItem
        })
      }
    } else if (item.code === 'appmarket-5-thryv-m2m') {
      if (item.addons.length > 0) {
        item.addons.map(addonItem => {
          monthlyAddons.push(getPlanDetail(currency, addonItem))
          return addonItem
        })
      }
    } else {
      monthlyAddons.push(getPlanDetail(currency, item))
    }

    return item
  })
  monthlyCenters = getSortedArray(monthlyCenters, 'name')
  monthlyAddons = getSortedArray(monthlyAddons, 'name')
  let cartList = [...monthlyCenters, ...monthlyAddons]
  let todayCartTotal = cartList
    .map(item => item.amount)
    .reduce((acc, curr) => acc + curr)
  let tax = subJSON?.paymentPreview?.tax || 0
  return {
    cartList,
    totalDue: todayCartTotal + tax,
    tax,
    paymentCartType: 'today',
  }
}

const COMMAND_CENTER_NAME_MAPPING = {
  'cc_basic-5-thryv-m2m': 'My Account',
  'cc_basicpls-5-thryv-m2m': 'My Account',
  'cc_plus-5-thryv-m2m': 'My Account Plus',
  'cc_pro-5-thryv-m2m': 'My Account Pro',
}

const FREE_ACCOUNT_CODES = ['addon-5-signatures_usage', 'app-websitebuilder']
export const formatSubDetails = (
  subJSON,
  subList,
  currency,
  recurlySubscriptions = null,
) => {
  let list = [...subList.centers, ...subList.apps, ...subList.oneTimeFees]
  let planArrayList = []
  let addonArrayList = []
  subJSON.plan.map(item => {
    let subExist = list.find(sublist => sublist?.code === item?.code)
    if (subExist) {
      let subCurrency = subExist?.currencies
      let subAmount = subCurrency.find(curr => curr.currency === currency)
      planArrayList.push({
        code: subExist.code,
        quantity: item?.quantity || subAmount?.quantity || 1,
        name: subExist.code.startsWith('cc_')
          ? COMMAND_CENTER_NAME_MAPPING[subExist?.code]
          : subExist.code.startsWith('bc-6')
            ? 'Business Center'
            : subExist.name,
        // ownedUnitAmount is what an already-owned line really costs the account
        // (can be 0, which the `||` below would swap for the catalog price).
        unitAmount:
          item?.ownedUnitAmount ??
          (item?.unitAmount || subAmount?.unitAmount || 0),
        addons: item.addons,
        isAlreadyAdded: item?.isAlreadyAdded || false,
        prodType: subExist.prod_type,
      })
      // if (subExist?.entitlements?.length) {
      //   subExist.entitlements.map(subItem => {
      //     let subCurrency = subItem?.currencies
      //     let subAmount = subCurrency.find(curr => curr.currency === currency)
      //     planArrayList.push({
      //       code: subItem.code,
      //       quantity: subAmount?.quantity || 1,
      //       name: subItem.name,
      //       unitAmount: subAmount?.unitAmount || 0,
      //     })
      //     return subItem
      //   })
      // }
    }

    return item
  })
  subJSON.addons.map(item => {
    let subExist = list.find(sublist => sublist?.code === item?.code)
    if (
      item?.code === 'appmarket-5-thryv-m2m' ||
      String(item?.code || '').startsWith('addon-5-keap-addons') ||
      String(item?.code || '').startsWith('addon-5-keap-addons-annual')
    ) {
      if (item?.addons) {
        item?.addons.map(addon => {
          console.log('addon' + JSON.stringify(addon))
          let subAddOnExist = list.find(
            sublist => sublist?.code === addon?.code,
          )
          if (FREE_ACCOUNT_CODES.includes(addon.code)) {
            addonArrayList.push({
              code: addon.code,
              quantity: addon?.quantity,
              name: addon.name,
              unitAmount: 0,
              isAlreadyAdded: true,
              parentProduct: item?.code,
            })
          } else {
            if (subAddOnExist) {
              let subCurrency = subAddOnExist?.currencies
              let subAmount = subCurrency.find(
                curr => curr.currency === currency,
              )
              if (
                String(addon?.code || '').includes(
                  'addon-5-keap-addcontacts',
                ) ||
                String(addon?.code || '').includes('addon-5-keap-textvoice') ||
                String(addon?.code || '').includes(
                  'addon-5-keap-addcontacts-annual',
                ) ||
                String(addon?.code || '').includes(
                  'addon-5-keap-textvoice-annual',
                ) ||
                String(addon?.code || '').includes(
                  'addon-5-keap-legacy-plusthis-premium-trans-annual',
                ) ||
                String(addon?.code || '').includes(
                  'addon-5-keap-legacy-graphly-contacts-annual',
                ) ||
                String(addon?.code || '').includes(
                  'addon-5-keap-legacy-plusthis-premium-trans-m2m',
                ) ||
                String(addon?.code || '').includes(
                  'addon-5-keap-legacy-graphly-contacts-m2m',
                )
              ) {
                const addonTierQty = parseFloat(addon?.quantity) || 0
                addonArrayList.push({
                  code: subAddOnExist.code,
                  quantity: getKeapAddonQuantityByAmount(
                    subAddOnExist.code,
                    addon.amount,
                    currency,
                    addon?.quantity || 1,
                  ),
                  name:
                    addonTierQty > 1
                      ? `${subAddOnExist.name}: ${addonTierQty}`
                      : subAddOnExist.name,
                  unitAmount: getKeapAddonUnitamountByQuantity(
                    subAddOnExist.code,
                    addon.amount,
                    currency,
                    addon?.quantity || 1,
                  ),
                  isAlreadyAdded: addon?.isAlreadyAdded,
                  parentProduct: item?.code,
                })
              } else {
                addonArrayList.push({
                  code: subAddOnExist.code,
                  quantity: addon?.quantity || 1,
                  // Quantity-based Keap add-ons (e.g. Additional User) show
                  // "(Nx)" like the core OOE payment link.
                  name:
                    String(item?.code || '').startsWith(
                      'addon-5-keap-addons',
                    ) && (addon?.quantity || 1) > 1
                      ? `${subAddOnExist.name} (${addon.quantity}x)`
                      : subAddOnExist.name,
                  // Prefer catalog per-unit price over order total (order may store qty×price)
                  unitAmount:
                    addon?.isAlreadyAdded && recurlySubscriptions
                      ? (recurlySubscriptions
                          .flatMap(s => s?.addons || [])
                          .find(a => a?.code === addon?.code)?.subtotal ??
                        subAmount?.unitAmount ??
                        addon?.unitAmount ??
                        0)
                      : (subAmount?.unitAmount ?? addon?.unitAmount ?? 0),
                  isAlreadyAdded: addon?.isAlreadyAdded,
                  parentProduct: item?.code,
                })
              }
            } else {
              addonArrayList.push({
                code: addon.code,
                quantity: addon?.quantity || 1,
                name: addon?.name || addon.code,
                unitAmount:
                  addon?.isAlreadyAdded && recurlySubscriptions
                    ? (recurlySubscriptions
                        .flatMap(s => s?.addons || [])
                        .find(a => a?.code === addon?.code)?.subtotal ??
                      addon?.unitAmount ??
                      addon?.amount ??
                      0)
                    : (addon?.unitAmount ?? addon?.amount ?? 0),
                isAlreadyAdded: addon?.isAlreadyAdded ?? false,
                parentProduct: item?.code,
              })
            }
          }

          return addon
        })
      }
      if (String(item?.code || '').startsWith('addon-5-keap-addons')) {
        let subCurrency = subExist?.currencies
        let subAmount = subCurrency?.find(c => c.currency === currency)
        addonArrayList.push({
          code: item.code,
          quantity: item?.quantity || 1,
          name: subExist?.name || item?.name || 'Keap Addons',
          unitAmount: subAmount?.unitAmount ?? 0,
          prodType: 'App',
        })
      }
    } else {
      if (subExist) {
        let subCurrency = subExist?.currencies
        let subAmount = subCurrency.find(curr => curr.currency === currency)

        // Check if this is a keap addon that needs quantity calculation
        let displayQuantity = item?.quantity || subAmount?.quantity || 1
        // Prefer catalog per-unit price over order data (order may store qty×price as unitAmount)
        let addonUnitAmount =
          subAmount?.unitAmount ?? item?.unitAmount ?? item?.amount ?? 0

        let displayName = subExist.name
        if (
          String(item?.code || '').includes('addon-5-keap-addcontacts') ||
          String(item?.code || '').includes('addon-5-keap-textvoice') ||
          String(item?.code || '').includes(
            'addon-5-keap-legacy-graphly-contacts',
          ) ||
          String(item?.code || '').includes('addon-5-keap-legacy-plusthis')
        ) {
          displayQuantity = 1
          addonUnitAmount = getKeapAddonUnitamountByQuantity(
            item.code,
            item.amount,
            currency,
            item.quantity,
          )
          const tierQty = parseFloat(item?.quantity) || 0
          if (tierQty > 1) displayName = `${subExist.name}: ${tierQty}`
        }

        addonArrayList.push({
          code: subExist.code,
          quantity: displayQuantity,
          name: displayName,
          unitAmount: addonUnitAmount,
          isAlreadyAdded: item?.isAlreadyAdded || false,
          parentProduct: subExist?.parentProduct,
          prodType: subExist.prod_type,
        })
        if (item?.addons) {
          item?.addons.map(addon => {
            let subAddOnExist = list.find(
              sublist => sublist?.code === addon?.code,
            )
            if (subAddOnExist) {
              let subCurrency = subAddOnExist?.currencies
              let subAmount = subCurrency.find(
                curr => curr.currency === currency,
              )
              addonArrayList.push({
                code: subAddOnExist.code,
                quantity: addon?.quantity || 1,
                name: subAddOnExist.name,
                unitAmount: addon?.unitAmount || subAmount?.unitAmount || 0,
                isAlreadyAdded: addon?.isAlreadyAdded,
                parentProduct: item?.code,
              })
            }
            return addon
          })
        }
      }
    }
    return item
  })
  let defaultAddons = [
    {
      name: 'Website Builder',
      code: 'app-websitebuilder',
      quantity: 1,
      unitAmount: 0,
    },
    {
      code: 'addon-5-signatures_usage',
      name: 'Signatures Usage',
      quantity: 1,
      unitAmount: 0,
    },
  ]

  // let defaultOneTimeAddon = [
  //   {
  //     code: 'thryvprfee',
  //     name: 'Onboarding Fee',
  //     quantity: 1,
  //     unitAmount: 250,
  //   },
  // ]

  let parentSub = [
    {
      code: 'cc_basicpls-5-thryv-m2m',
      name: 'My Account Basic+',
      quantity: 1,
      unitAmount: 0,
    },
  ]
  let allAddOns = [...addonArrayList]
  // Links from the Account Setup wizard store one-time fees as code/quantity/
  // unitAmount only (legacy KP links carried the catalog name), which left the
  // summary row blank — resolve the name from the catalog.
  let oneTimeFees = (subJSON.oneTimeFees || []).map(fee => {
    if (fee?.name) return fee
    const catalogFee = list.find(sublist => sublist?.code === fee?.code)
    return catalogFee?.name ? {...fee, name: catalogFee.name} : fee
  })
  let planList = [...planArrayList, ...addonArrayList, ...oneTimeFees]
  let upgradeOrder = planList.some(item => item?.isAlreadyAdded)
  if (!upgradeOrder) {
    planList = [...parentSub, ...planList, ...defaultAddons]
  }

  // const monthlyPlanList = planList.filter(item => !oneTimeFees.includes(item))

  // let totalAmountMonthly = planList
  //   .map(item => item.unitAmount * (item.quantity || 1))
  //   .reduce((acc, curr) => acc + curr)
  let totalAmountMonthly = planList
    .flatMap(item => [
      item.unitAmount * (item.quantity || 1),
      ...(item.addons?.map(
        addon => (addon.unitAmount || 0) * (addon.quantity || 1),
      ) || []),
    ])
    .reduce((acc, curr) => acc + curr, 0)
  console.log({totalAmountMonthly})
  let totalAmountToday = planList
    .map(item => {
      if (item?.isAlreadyAdded) {
        return (item?.addons || [])
          .filter(addon => !addon?.isAlreadyAdded)
          .reduce(
            (sum, addon) =>
              sum + (addon.unitAmount || 0) * (addon.quantity || 1),
            0,
          )
      }
      return item.unitAmount * (item.quantity || 1)
    })
    .reduce((acc, curr) => acc + curr, 0)
  let totalDeduction = 0
  if (subJSON.coupons && subJSON.coupons.length > 0) {
    for (let i = 0; i < subJSON.coupons.length; i++) {
      if (subJSON.coupons[i].type === 'fixed') {
        totalDeduction = totalDeduction + subJSON.coupons[i].discountAmount
      } else {
        let validPlanCodes = subJSON.coupons[i]?.appliesToPlans || []
        let appropriatePlan = planList?.find(item =>
          validPlanCodes.includes(item.code),
        )
        if (appropriatePlan) {
          totalDeduction =
            totalDeduction +
            subJSON.coupons[i].discountPercent *
              0.01 *
              appropriatePlan.unitAmount *
              appropriatePlan.quantity
        }
      }
    }
  }
  if (totalDeduction > 0) {
    totalAmountToday = totalAmountToday - totalDeduction
  }

  const keapAddonsByWrapper = allAddOns.reduce((result, addon) => {
    const wrapperCode = addon?.parentProduct
    if (
      !String(wrapperCode || '').startsWith('addon-5-keap-addons') &&
      !String(wrapperCode || '').startsWith('addon-5-keap-addons-annual')
    ) {
      return result
    }
    if (!result[wrapperCode]) {
      result[wrapperCode] = []
    }
    result[wrapperCode].push(addon)
    return result
  }, {})
  const nonKeapAddons = allAddOns.filter(
    ({parentProduct, code}) =>
      !String(parentProduct || '').startsWith('addon-5-keap-addons') &&
      !String(parentProduct || '').startsWith('addon-5-keap-addons-annual') &&
      !String(code || '').startsWith('addon-5-keap-addons'),
  )

  let childSubscriptions = []
  for (let plan of planArrayList) {
    childSubscriptions.push(plan)
  }

  Object.entries(keapAddonsByWrapper).forEach(([wrapperCode, addons]) => {
    childSubscriptions.push({
      code: wrapperCode,
      quantity: 1,
      addons: addons.map(({code, unitAmount, quantity}) => ({
        code,
        quantity: getKeapAddonQuantityByAmount(
          code,
          unitAmount,
          currency,
          quantity,
        ),
      })),
    })
  })

  // Push keap addon wrappers that have no children (empty addons array)
  allAddOns
    .filter(
      ({code}) =>
        String(code || '').startsWith('addon-5-keap-addons') &&
        !keapAddonsByWrapper[code],
    )
    .forEach(({code, quantity, name, unitAmount}) => {
      childSubscriptions.push({
        code,
        quantity: quantity || 1,
        name,
        unitAmount,
        addons: [],
      })
    })

  childSubscriptions.push({
    code: 'appmarket-5-thryv-m2m',
    quantity: 1,
    addons: nonKeapAddons
      .filter(({name, code}) => {
        return (
          name !== 'SEO Keywords' &&
          name !== 'AEO & SEO PowerBoost' &&
          name !== 'SEO Non-Guaranteed' &&
          name !== 'Thryv Leads' &&
          name !== 'AEO & SEO'
        )
      })
      .map(({code, quantity = 1, name}) => {
        return {
          code,
          quantity,
          name,
        }
      }),
  })
  const isSeo = addonArrayList.find(({name}) => name === 'AEO & SEO')
  if (isSeo) {
    const keyword = addonArrayList.find(({name}) => name === 'SEO Keywords')
    const powerboost = addonArrayList.find(
      ({name}) => name === 'AEO & SEO PowerBoost',
    )
    for (let addOn of addonArrayList) {
      if (addOn.code === 'seobase-5-thryv-m2m') {
        addOn.addons = []
        if (keyword) addOn.addons.push(keyword)
        if (powerboost) addOn.addons.push(powerboost)
        childSubscriptions.push(addOn)
      }
    }
    planList = planList.filter(
      ({name}) => name !== 'SEO Keywords' && name !== 'AEO & SEO PowerBoost',
    )
  }

  return {
    plans: planList,
    totalAmount: totalAmountMonthly,
    monthlyPlans: planList,
    totalAmountToday: totalAmountToday,
    upgradeOrder: planList.some(item => item?.isAlreadyAdded),
    productSub: {
      parentSubscriptions: [...parentSub],
      childSubscriptions: childSubscriptions,
      oneTimeFees: [...oneTimeFees],
    },
  }
}
export const formatInCodeQuantityStructure = subDetails => {
  let parentSubscriptions = []
  let childSubscriptions = []
  let oneTimeFees = []

  subDetails.parentSubscriptions.map(item => {
    let tempDetails = {
      code: item.code,
      quantity: item?.quantity || 1,
      addons: [],
    }
    let tempAddons = []
    if (item?.addons?.length > 0) {
      item.addons.map(subItem => {
        tempAddons.push({code: subItem.code, quantity: subItem?.quantity || 1})
        return subItem
      })
    }
    tempDetails.addons = tempAddons
    parentSubscriptions.push(tempDetails)
    return item
  })
  subDetails.childSubscriptions.map(item => {
    let tempDetails = {
      code: item.code,
      quantity: item?.quantity || 1,
      addons: [],
    }
    let tempAddons = []
    if (item?.addons?.length > 0) {
      item.addons.map(subItem => {
        tempAddons.push({code: subItem.code, quantity: subItem?.quantity || 1})
        return subItem
      })
    }
    tempDetails.addons = tempAddons
    childSubscriptions.push(tempDetails)
    return item
  })
  subDetails?.oneTimeFees?.map(item => {
    let tempDetails = {
      code: item.code,
      quantity: item?.quantity || 1,
      addons: [],
    }
    let tempAddons = []
    if (item?.addons?.length > 0) {
      item.addons.map(subItem => {
        tempAddons.push({code: subItem.code, quantity: subItem?.quantity || 1})
        return subItem
      })
    }
    tempDetails.addons = tempAddons
    oneTimeFees.push(tempDetails)
    return item
  })
  return {parentSubscriptions, childSubscriptions, oneTimeFees}
}

export function getFormattedTime(dateStr) {
  return dayjs(dateStr.start_time).tz(dateStr.timezone).format('h:mm A z')
}
export function getFormattedDate(dateStr) {
  return dayjs(dateStr.start_time).tz(dateStr.timezone).format('D MMM YYYY')
}

export function getFormattedDateTime(dateStr) {
  if (dateStr?.timezone && dateStr?.timezone?.length > 0) {
    if (dateStr?.timezone?.includes('Eastern Daylight Time')) {
      return (
        dayjs(dateStr?.start_time).format('MMMM D[,] YYYY [@] h:mm A ') + 'EDT'
      )
    } else {
      return dayjs(dateStr?.start_time)
        .tz(dateStr?.timezone)
        .format('MMMM D[,] YYYY [@] h:mm A z')
    }
  } else {
    return (
      dayjs(dateStr?.start_time).format('MMMM D[,] YYYY [@] h:mm A ') + 'CDT'
    )
  }
}
